import CustomComponent from "./PopupCustom";

export default (Vue) => {
    Vue.component(CustomComponent.name, CustomComponent);
};
